import * as i0 from "@angular/core";
//import { Utilities } from './utilities';
export class LocalStoreManager {
    constructor() {
        this.syncKeys = [];
        this.reservedKeys = [
            'sync_keys',
            'addToSyncKeys',
            'removeFromSyncKeys',
            'getSessionStorage',
            'setSessionStorage',
            'addToSessionStorage',
            'removeFromSessionStorage',
            'clearAllSessionsStorage'
        ];
    }
    saveSessionData(data, key = LocalStoreManager.DBKEY_USER_DATA) {
        this.testForInvalidKeys(key);
        //this.removeFromSyncKeys(key);
        localStorage.removeItem(key);
        this.sessionStorageSetItem(key, data);
    }
    savePermanentData(data, key = LocalStoreManager.DBKEY_USER_DATA) {
        this.testForInvalidKeys(key);
        this.removeFromSessionStorage(key);
        this.localStorageSetItem(key, data);
    }
    exists(key = LocalStoreManager.DBKEY_USER_DATA) {
        let data = sessionStorage.getItem(key);
        if (data == null)
            data = localStorage.getItem(key);
        return data != null;
    }
    getData(key = LocalStoreManager.DBKEY_USER_DATA) {
        this.testForInvalidKeys(key);
        let data = this.sessionStorageGetItem(key);
        if (data == null)
            data = this.localStorageGetItem(key);
        return data;
    }
    getDataObject(key = LocalStoreManager.DBKEY_USER_DATA, isDateType = false) {
        let data = this.getData(key);
        if (data != null) {
            if (isDateType)
                data = new Date(data);
            return data;
        }
        else {
            return null;
        }
    }
    deleteData(key = LocalStoreManager.DBKEY_USER_DATA) {
        this.testForInvalidKeys(key);
        this.removeFromSessionStorage(key);
        localStorage.removeItem(key);
    }
    localStorageSetItem(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }
    sessionStorageSetItem(key, data) {
        sessionStorage.setItem(key, JSON.stringify(data));
    }
    localStorageGetItem(key) {
        return this.JSonTryParse(localStorage.getItem(key));
    }
    sessionStorageGetItem(key) {
        return this.JSonTryParse(sessionStorage.getItem(key));
    }
    removeFromSessionStorage(keyToRemove) {
        this.removeFromSessionStorageHelper(keyToRemove);
        //this.removeFromSyncKeysBackup(keyToRemove);
        //localStorage.setItem('removeFromSessionStorage', keyToRemove);
        //localStorage.removeItem('removeFromSessionStorage');
    }
    removeFromSessionStorageHelper(keyToRemove) {
        sessionStorage.removeItem(keyToRemove);
        //this.removeFromSyncKeysHelper(keyToRemove);
    }
    testForInvalidKeys(key) {
        if (!key)
            throw new Error("key cannot be empty");
        if (this.reservedKeys.some(x => x == key))
            throw new Error(`The storage key "${key}" is reserved and cannot be used. Please use a different key`);
    }
    JSonTryParse(value) {
        try {
            return JSON.parse(value);
        }
        catch (e) {
            if (value === "undefined")
                return void 0;
            return value;
        }
    }
    clearAllSessionsStorage() {
        this.clearInstanceSessionStorage();
        //localStorage.removeItem(LocalStoreManager.DBKEY_SYNC_KEYS);
        //localStorage.setItem('clearAllSessionsStorage', '_dummy');
        //localStorage.removeItem('clearAllSessionsStorage');
    }
    clearInstanceSessionStorage() {
        sessionStorage.clear();
        this.syncKeys = [];
    }
    clearLocalStorage() {
        localStorage.clear();
    }
}
LocalStoreManager.DBKEY_USER_DATA = "user_data";
LocalStoreManager.DBKEY_SYNC_KEYS = "sync_keys";
LocalStoreManager.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LocalStoreManager_Factory() { return new LocalStoreManager(); }, token: LocalStoreManager, providedIn: "root" });
